var React = require('react');

function Vk (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M187.6,7.6c1.3-4.5,0-7.6-6.3-7.6h-21c-5.4,0-7.8,2.8-9.1,6c0,0-10.6,26.1-25.8,42.8c-4.9,4.9-7,6.4-9.7,6.4\n\t\tc-1.3,0-3.3-1.5-3.3-6V7.6c0-5.4-1.5-7.6-6-7.6h-33C70.1,0,68,2.5,68,4.8c0,5.1,7.5,6.3,8.4,20.4v30.9c0,6.7-1.2,7.9-3.9,7.9\n\t\tc-7,0-24.4-26.1-34.6-56c-2.1-5.5-4-7.9-9.4-7.9h-21c-6,0-7.2,2.8-7.2,6c0,5.5,7,33.1,33.1,69.5c17.4,24.9,41.8,38.3,64,38.3\n\t\tc13.3,0,15-3,15-8.1V86.9c0-6,1.2-7.2,5.5-7.2c3.1,0,8.4,1.5,20.8,13.5c14.2,14.2,16.6,20.7,24.6,20.7h21c6,0,9-3,7.2-8.8\n\t\tc-1.9-5.8-8.7-14.4-17.7-24.6c-4.9-5.8-12.3-12-14.4-15.1c-3.1-4-2.2-5.8,0-9.3C159.4,55.9,185,19.9,187.6,7.6z"})));
}

Vk.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 192 113.9","style":{"enableBackground":"new 0 0 192 113.9"},"xmlSpace":"preserve"};

module.exports = Vk;

Vk.default = Vk;
